import { reportClientError } from './clientLogger';

let installed = false;

function messageFrom(value: unknown): string {
  if (value instanceof Error) return value.stack ?? value.message;
  return String(value);
}

// Wire window-level `error` + `unhandledrejection` to the client error sink so
// failures that escape React's tree (async handlers, event callbacks, bare
// rejections) still reach CloudWatch. Idempotent — safe to call once at boot.
export function installGlobalErrorHandlers(): void {
  if (installed || typeof window === 'undefined') return;
  installed = true;

  window.addEventListener('error', (event) => {
    const message = event.error
      ? messageFrom(event.error)
      : event.message || 'Unknown window error';
    reportClientError(message, {
      type: 'error',
      source: event.filename,
      line: event.lineno,
    });
  });

  window.addEventListener('unhandledrejection', (event) => {
    reportClientError(`Unhandled rejection: ${messageFrom(event.reason)}`, {
      type: 'unhandledrejection',
    });
  });
}

// Test seam.
export function resetGlobalErrorHandlersForTesting(): void {
  installed = false;
}
